import React from 'react'
import Menu from './menu/Menu';
import Navbar from '../Navbar';

const HomePage = () => {


  return (
    <div>
      <Navbar />
      <Menu />
    </div>
  )
}

export default HomePage
